import styled, { css } from 'styled-components';

export const Wrap = styled.div``;

export const Form = styled.form`
  border: 1px solid #dee3eb;
  ${(props) =>
    props.isReply &&
    css`
      border-color: #ed2026;
    `}
  textarea {
    width: 100%;
    padding: 11px 12px;
    height: 135px;
    resize: none;
    outline: none;
    color: #333;
    box-sizing: border-box;
    line-height: 1.6em;
    border: 0;
  }
  > div {
    height: 50px;
    background: #fafafa;
    border-top: 1px solid #ebeef3;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 10px;
    gap: 10px;

    > button[type='submit'] {
      background: #ed2026;
      color: #fff;
      width: 75px;
      height: 30px;
    }
  }
`;

export const CommentCount = styled.div`
  height: 40px;
  margin-top: 20px;
  border-bottom: 1px solid #dee3eb;
  font-size: 12px;
  display: flex;
  align-items: center;
  > em {
    color: #ed2026;
    margin-left: 5px;
  }
`;

export const List = styled.ul``;

export const ListItem = styled.li`
  border-bottom: 1px solid #dee3eb;
  display: flex;
  flex-direction: column;
  min-height: 120px;
  padding: 17px 0 11px;
  box-sizing: border-box;
  ${(props) =>
    props.isReply &&
    css`
      border: 0;
      padding-left: 20px;
    `}
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  > img {
    width: 23px;
    height: 23px;
    margin-right: 6px;
    border-radius: 50%;
  }
  > em {
    font-size: 12px;
  }
  > span {
    display: flex;
    align-items: flex-start;
    color: #ccc;
    :before {
      content: '·';
      display: block;
      margin: 0 7px;
    }
  }
`;

export const Content = styled.div`
  padding: 10px 0;
  line-height: 1.4em;
  word-break: break-all;
`;

export const Buttons = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  > button {
    display: flex;
    align-items: center;
    :hover {
      text-decoration: none;
    }
    :not(:last-child) {
      :after {
        content: '·';
        display: block;
        margin-left: 7px;
      }
    }
    :not(:first-child) {
      padding-left: 7px;
    }
    &.active {
      color: #ed2026;
    }
    &.me {
      cursor: default;
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;

  button {
    padding: 5px 10px;
    border: 1px solid #ccc;
    background: white;
    cursor: pointer;
    border-radius: 4px;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;
